import { useEffect, useState } from "react";
import { Trash2, Mail, Phone, CheckCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { StatusBadge, ActionBtn } from "./Bits";

export const MessagesPanel = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/admin/messages")
      .then(({ data }) => setItems(Array.isArray(data) ? data : []))
      .catch((e) => toast.error(formatApiError(e.response?.data?.detail)))
      .finally(() => setLoading(false));
  }, []);

  const markRead = async (id) => {
    try {
      const { data } = await api.patch(`/admin/messages/${id}`, { status: "read" });
      setItems((xs) => xs.map((x) => (x.id === id ? data : x)));
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Delete this message?")) return;
    try {
      await api.delete(`/admin/messages/${id}`);
      setItems((xs) => xs.filter((x) => x.id !== id));
      toast.success("Message deleted");
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  return (
    <div data-testid="messages-panel" className="space-y-3">
      {!loading && items.length === 0 && (
        <p data-testid="messages-empty" className="border border-dashed border-[#D4AF37]/20 p-10 text-center text-slate-400">No messages yet.</p>
      )}
      {items.map((m) => (
        <div key={m.id} data-testid={`message-row-${m.id}`} className="border border-[#D4AF37]/15 bg-[#0E081D] p-5">
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <p className="font-medium text-white">{m.name} {m.subject && <span className="text-slate-400">· {m.subject}</span>}</p>
              <div className="mt-1 flex flex-wrap gap-x-4 text-sm text-slate-300">
                <a href={`mailto:${m.email}`} className="flex items-center gap-1.5 hover:text-white"><Mail className="h-3.5 w-3.5" />{m.email}</a>
                {m.phone && <a href={`tel:${m.phone}`} className="flex items-center gap-1.5 hover:text-white"><Phone className="h-3.5 w-3.5" />{m.phone}</a>}
              </div>
            </div>
            <div className="flex items-center gap-2">
              <StatusBadge status={m.status} testId={`message-status-${m.id}`} />
              {m.status === "new" && <ActionBtn testId={`message-read-${m.id}`} onClick={() => markRead(m.id)}><CheckCheck className="h-3.5 w-3.5" />Mark read</ActionBtn>}
              <ActionBtn tone="danger" testId={`message-delete-${m.id}`} onClick={() => remove(m.id)}><Trash2 className="h-3.5 w-3.5" /></ActionBtn>
            </div>
          </div>
          <p className="mt-4 whitespace-pre-wrap text-sm leading-relaxed text-slate-200">{m.message}</p>
          <p className="mt-3 text-xs text-slate-400">{new Date(m.created_at).toLocaleString()}</p>
        </div>
      ))}
    </div>
  );
};
